(() => {
  if (customElements.get('featured-product-lp-rating')) return;

  class FeaturedProductLpRating extends HTMLElement {
    constructor() {
      super();
      this.onMutations = this.onMutations.bind(this);
      this.observer = new MutationObserver(this.onMutations);
    }

    connectedCallback() {
      this.template = this.querySelector('[data-featured-product-rating-template]');
      this.templateSignature = this.createSignature(this.template?.innerHTML || '');
      this.observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-rating', 'data-reviews'],
      });
      this.updateRatings();
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    onMutations() {
      this.updateRatings();
    }

    createSignature(value) {
      let signature = 0;

      for (let index = 0; index < value.length; index += 1) {
        signature = (signature * 31 + value.charCodeAt(index)) | 0;
      }

      return String(signature);
    }

    updateStars(caption, value) {
      const rating = Math.round(parseFloat(value) * 2) / 2;
      const container = caption.parentElement;
      if (Number.isNaN(rating) || !container) return;

      container.querySelectorAll('i').forEach((star, index) => {
        const position = index + 1;
        star.classList.toggle('stamped-fa-star', rating >= position);
        star.classList.toggle('stamped-fa-star-half-o', rating === position - 0.5);
        star.classList.toggle('stamped-fa-star-o', rating < position - 0.5);
      });
    }

    updateRatings() {
      if (!this.template) return;

      const manualRating = this.dataset.manualRating;

      this.querySelectorAll('product-new-rating [data-rating][data-reviews]').forEach((caption) => {
        if (caption.querySelector('[data-rating][data-reviews]')) return;

        const ratingValue = manualRating || caption.dataset.rating;
        if (manualRating) this.updateStars(caption, manualRating);

        const signature = `${this.templateSignature}|${ratingValue}|${caption.dataset.reviews}`;
        const currentContent = caption.querySelector('[data-featured-product-rating-content]');
        if (currentContent && caption.dataset.featuredProductRatingSignature === signature) return;

        const content = this.template.content.cloneNode(true);
        const rating = content.querySelector('[data-featured-product-rating-value]');
        const textBeforeIcon = content.querySelector('[data-featured-product-rating-text]');
        const textAfterIcon = content.querySelector('[data-featured-product-rating-text-after]');

        if (rating) rating.textContent = ratingValue;
        if (textBeforeIcon) {
          textBeforeIcon.textContent = textBeforeIcon.textContent.replaceAll('[reviews]', caption.dataset.reviews);
        }
        if (textAfterIcon) {
          textAfterIcon.textContent = textAfterIcon.textContent.replaceAll('[reviews]', caption.dataset.reviews);
        }

        caption.replaceChildren(content);
        caption.dataset.featuredProductRatingSignature = signature;
      });
    }
  }

  customElements.define('featured-product-lp-rating', FeaturedProductLpRating);
})();
